// ==============API CREATION OF FAQ ================
export const FAQ_CREATE_REQUEST = 'faq create requesting'
export const FAQ_CREATE_SUCCESS = 'faq create succeeded'
export const FAQ_CREATE_FAILURE= 'faq create failed'
// ==============API READ OF FAQ ================
export const FAQ_READ_REQUEST = 'faq read requesting'
export const FAQ_READ_SUCCESS = 'faq read succeeded'
export const FAQ_READ_FAILURE= 'faq read failed'
// ==============API UPDATE OF FAQ ================
export const FAQ_UPDATE_REQUEST = 'faq update requesting'
export const FAQ_UPDATE_SUCCESS = 'faq update succeeded'
export const FAQ_UPDATE_FAILURE= 'faq update failed'
// ==============API DELETION OF FAQ ================
export const FAQ_DELETE_REQUEST = 'faq delete requesting'
export const FAQ_DELETE_SUCCESS = 'faq delete succeeded'
export const FAQ_DELETE_FAILURE= 'faq delete failed'
// ============== SET CURRENT PAYLOAD ============
export const FAQ_SET_CURRENT_PAYLOAD = 'faq set current payload'
export const FAQ_SET_CURRENT_ITEM = 'faq set current item'


// ==============API create OF FAQ ================
export function faqCreateRequest(isFetching) {
  return {
    type: FAQ_CREATE_REQUEST,
    isFetching: isFetching,
  }
}

export function faqCreateSuccess(faqs) {
  return {
    type: FAQ_CREATE_SUCCESS,
    faqs: faqs,
  }
}

export function faqCreateFailure(error, response) {
  return {
    type: FAQ_CREATE_FAILURE,
    error: error,
    response: response
  }
}


// ==============API read OF FAQ ================
export function faqReadRequest(isFetching) {
  return {
    type: FAQ_READ_REQUEST,
    isFetching: isFetching,
  }
}

export function faqReadSuccess(faqs) {
  return {
    type: FAQ_READ_SUCCESS,
    faqs: faqs,
  }
}

export function faqReadFailure(error, response) {
  return {
    type: FAQ_READ_FAILURE,
    error: error,
    response: response
  }
}

// ==============API UPDATE OF FAQ ================
export function faqUpdateRequest(isFetching) {
  return {
    type: FAQ_UPDATE_REQUEST,
    isFetching: isFetching,
  }
}

export function faqUpdateSuccess(faqs) {
  return {
    type: FAQ_UPDATE_SUCCESS,
    faqs: faqs,
  }
}

export function faqUpdateFailure(error, response) {
  return {
    type: FAQ_UPDATE_FAILURE,
    error: error,
    response: response
  }
}

// ==============API DELETION OF FAQ ================
export function faqDeleteRequest(isFetching) {
  return {
    type: FAQ_DELETE_REQUEST,
    isFetching: isFetching,
  }
}

export function faqDeleteSuccess(faqs) {
  return {
    type: FAQ_DELETE_SUCCESS,
    faqs: faqs,
  }
}

export function faqDeleteFailure(error, response) {
  return {
    type: FAQ_DELETE_FAILURE,
    error: error,
    response: response
  }
}


// ============== SET CURRENT PAYLOAD ============
export function faqSetCurrentPayload(payload) {
    return {
        type: FAQ_SET_CURRENT_PAYLOAD,
        payload: payload
    }
}

export function faqSetCurrentItem(id) {
    return {
        type: FAQ_SET_CURRENT_ITEM,
        id: id
    }
}



// WEBPACK FOOTER //
// ./src/model/FAQ/actions.js